export const formatDate = dateStr => {
  const dateArr = dateStr.split('/') // [dd, mm, yyyy]

  return dateArr.join('-')
}

export const formatDateTime = dateStr => {
  const date = new Date(dateStr).toLocaleDateString()
  const time = new Date(dateStr).toLocaleTimeString()

  const dateTime = `${formatDate(date)} ${time}`

  return dateTime
}
